// extracted by mini-css-extract-plugin
export default {"container":"WorksheetSettingsBlock_container__jKJcW","header":"WorksheetSettingsBlock_header__Qrr2o","description":"WorksheetSettingsBlock_description__AEmn+"};